module.exports = __webpack_public_path__ + "img/WhatsApp.4025a2c2.svg";